import type { ReactNode } from "react";

import { Sidebar, type NavKey } from "./Sidebar";
import { Topbar, type TopbarProps } from "./Topbar";

export interface ShellLayoutProps {
  active: NavKey;
  topbar: TopbarProps;
  children?: ReactNode;
}

export function ShellLayout({
  active,
  topbar,
  children,
}: ShellLayoutProps): ReactNode {
  return (
    <div className="flex h-screen bg-n-75 font-sans text-n-900">
      <Sidebar active={active} />
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar {...topbar} />
        <div className="min-h-0 flex-1 overflow-auto">{children}</div>
      </main>
    </div>
  );
}
